var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notice.showNotice)?_c('div',{staticClass:"global-notice",class:{ 'notice-closed': !_vm.showNotice }},[_c('div',{staticClass:"notice-content"},[_c('span',{staticClass:"notice-text"},[_vm._v(_vm._s(_vm.notice.content))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }